import { getConfig } from '@monorepo/tools/src/lib/get-config';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { getManagementApiBaseUrl } from '../../utils/management-api';

export class BidderEndpoints {
	private rootApi: string;
	private baseUrl: string;
	private crudUrl: string;

	constructor() {
		this.rootApi = getManagementApiBaseUrl();
		this.baseUrl = `${this.rootApi}/bidder`;
		this.crudUrl = `${getConfig().env.sheriffRoot}/adminx-bidder/admin`;
	}

	inputOptions(path: string) {
		return `${this.crudUrl}/${path}`;
	}

	whitelist(path: string) {
		return `${this.crudUrl}/${path}`;
	}

	campaigns() {
		return `${this.baseUrl}/campaigns`;
	}

	getPublishers() {
		return `${this.crudUrl}/getPublishers`;
	}

	getAdvertisers() {
		return `${this.crudUrl}/getAdvertisers`;
	}

	getCampaignGroups(id: id) {
		return `${this.crudUrl}/getCampaignGroups?id=${id}`;
	}

	getStateMachineIds() {
		return `${this.crudUrl}/getStateMachineIds`;
	}

	getCampaign(id: id) {
		return `${this.crudUrl}/getCampaignDetails?id=${id}`;
	}

	getAdvertiser(id: id) {
		return `${this.crudUrl}/getAdvertiserDetails?id=${id}`;
	}

	getCampaigns() {
		return `${this.crudUrl}/getCampaigns`;
	}

	getModels() {
		return `${this.crudUrl}/getModels`;
	}

	updateModel() {
		return `${this.crudUrl}/updateModel`;
	}

	rebuildModel(modelName: string) {
		return `${this.crudUrl}/rebuildModel?model_name=${encodeURIComponent(modelName)}`;
	}

	createCampaign() {
		return `${this.crudUrl}/createCampaign`;
	}

	createAdvertiser() {
		return `${this.crudUrl}/createAdvertiser`;
	}

	cloneCampaign() {
		return `${this.crudUrl}/cloneCampaign`;
	}

	updateCampaign() {
		return `${this.crudUrl}/updateCampaign`;
	}

	updateAdvertiser() {
		return `${this.crudUrl}/updateAdvertiser`;
	}

	enableCampaign(id: id) {
		return `${this.crudUrl}/activateCampaign?id=${id}`;
	}

	enableAdvertiser(id: id) {
		return `${this.crudUrl}/activateAdvertiser?id=${id}`;
	}

	pauseCampaign(id: id) {
		return `${this.crudUrl}/pauseCampaign?id=${id}`;
	}

	pauseAdvertiser(id: id) {
		return `${this.crudUrl}/pauseAdvertiser?id=${id}`;
	}

	ackCampaignNote(id: id) {
		return `${this.crudUrl}/ackCampaignNote?id=${id}`;
	}

	getApiChangesLogData(params?: { ts_start?: string; ts_end?: string; id?: id }) {
		const baseUrl = `${this.crudUrl}/getApiChangesLogData`;

		if (!params) {
			return baseUrl;
		}

		const queryParams = new URLSearchParams();

		if (params.ts_start) {
			queryParams.append('ts_start', params.ts_start);
		}

		if (params.ts_end) {
			queryParams.append('ts_end', params.ts_end);
		}

		if (params.id) {
			queryParams.append('id', params.id.toString());
		}

		const queryString = queryParams.toString();
		return queryString ? `${baseUrl}?${queryString}` : baseUrl;
	}

	downloadApiChangesLogData(params?: { ts_start?: string; ts_end?: string; id?: id }) {
		const baseUrl = `${this.crudUrl}/downloadApiChangesLogData`;
		if (!params) {
			return baseUrl;
		}
		const queryParams = new URLSearchParams();
		if (params.ts_start) {
			queryParams.append('ts_start', params.ts_start);
		}
		if (params.ts_end) {
			queryParams.append('ts_end', params.ts_end);
		}
		if (params.id) {
			queryParams.append('id', params.id.toString());
		}
		const queryString = queryParams.toString();
		return queryString ? `${baseUrl}?${queryString}` : baseUrl;
	}

	deleteTargetingLinkCache() {
		return `${this.crudUrl}/deleteTargetingLinkCache`;
	}

	setBadIspWordsPerAdvertiser() {
		return `${this.crudUrl}/setBadIspWordsPerAdvertiser`;
	}

	setBadIspWordsPerCampaign() {
		return `${this.crudUrl}/setBadIspWordsPerCampaign`;
	}

	getTrafficEntities() {
		return `${this.crudUrl}/getTrafficEntities`;
	}

	createTrafficEntity() {
		return `${this.crudUrl}/createTrafficEntity`;
	}

	updateTrafficEntity() {
		return `${this.crudUrl}/updateTrafficEntity`;
	}
}
